export const header = [
  {
    id: 0,
    title: 'О Generium',
    alt: 'vector',
    to: 'https://www.generium.ru/'
  },
  {
    id: 5,
    title: 'Мы в СМИ',
    alt: 'vector',
    to: '/media'
  },
  {
    id: 1,
    title: 'Все вакансии',
    alt: 'vector',
    to: '/listing'
  },
  {
    id: 2,
    title: 'Релокация',
    alt: 'vector',
    to: '/relocation'
  },
  {
    id: 3,
    title: 'Студентам',
    alt: 'vector'
  },
  {
    id: 4,
    title: 'Откликнуться',
    alt: 'vector'
  }
]
